import React, { useState, useEffect } from 'react';
import API_BASE_URL from '../../config/api';
import { Trash2, Plus, Save, X } from 'lucide-react';

const KnowledgeBase = () => {
    const [entries, setEntries] = useState([]);
    const [isAdding, setIsAdding] = useState(false);
    const [formData, setFormData] = useState({ topic: '', content: '', tags: '', priority: 0 });

    const fetchEntries = async () => {
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${API_BASE_URL}/chat/knowledge`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            console.log("Fetch Entries Status:", res.status);
            if (!res.ok) {
                const text = await res.text();
                console.error("Fetch Entries Error:", text);
                return;
            }
            const json = await res.json();
            console.log("Fetch Entries Data:", json);
            if (json.status === 'success') {
                setEntries(json.data);
            }
        } catch (err) {
            console.error("Failed to load knowledge base", err);
        }
    };

    useEffect(() => {
        fetchEntries();
    }, []);

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure?")) return;
        try {
            const token = localStorage.getItem('token');
            await fetch(`${API_BASE_URL}/chat/knowledge/${id}`, {
                method: 'DELETE',
                headers: { Authorization: `Bearer ${token}` }
            });
            fetchEntries();
        } catch (e) {
            alert("Failed to delete");
        }
    };

    const handleSave = async () => {
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${API_BASE_URL}/chat/knowledge`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify(formData)
            });
            const json = await res.json();
            if (json.status === 'success') {
                setIsAdding(false);
                setFormData({ topic: '', content: '', tags: '', priority: 0 });
                fetchEntries();
            } else {
                alert(`Failed to save: ${json.message}`);
            }
        } catch (e) {
            console.error(e);
            alert("Failed to save: " + e.message);
        }
    };

    return (
        <div className="p-6 bg-white rounded-lg shadow-sm border border-gray-200">
            <div className="flex justify-between items-center mb-6">
                <div>
                    <h2 className="text-xl font-bold text-gray-900">AI Knowledge Base</h2>
                    <p className="text-sm text-gray-500">Train your Chatbot with custom knowledge snippets.</p>
                </div>
                <button
                    onClick={() => setIsAdding(true)}
                    className="flex items-center gap-2 bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition-colors"
                >
                    <Plus size={18} /> Add Entry
                </button>
            </div>

            {isAdding && (
                <div className="mb-8 p-6 bg-gray-50 rounded-xl border border-gray-200 animate-fadeIn">
                    <div className="flex justify-between mb-4">
                        <h3 className="font-semibold text-gray-800">New Knowledge Entry</h3>
                        <button onClick={() => setIsAdding(false)} className="text-gray-400 hover:text-gray-600"><X size={20} /></button>
                    </div>
                    <div className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Topic / Question</label>
                            <input
                                className="w-full border border-gray-300 rounded-lg px-3 py-2 outline-none focus:border-black"
                                placeholder="e.g., What is the return policy?"
                                value={formData.topic}
                                onChange={e => setFormData({ ...formData, topic: e.target.value })}
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Answer / Content</label>
                            <textarea
                                className="w-full border border-gray-300 rounded-lg px-3 py-2 outline-none focus:border-black min-h-[100px]"
                                placeholder="The answer the AI should use..."
                                value={formData.content}
                                onChange={e => setFormData({ ...formData, content: e.target.value })}
                            />
                        </div>
                        <div className="flex gap-4">
                            <div className="flex-1">
                                <label className="block text-sm font-medium text-gray-700 mb-1">Tags (comma separated)</label>
                                <input
                                    className="w-full border border-gray-300 rounded-lg px-3 py-2 outline-none focus:border-black"
                                    placeholder="returns, refund, shipping"
                                    value={formData.tags}
                                    onChange={e => setFormData({ ...formData, tags: e.target.value })}
                                />
                            </div>
                            <div className="w-1/4">
                                <label className="block text-sm font-medium text-gray-700 mb-1">Priority (0-10)</label>
                                <input
                                    type="number"
                                    className="w-full border border-gray-300 rounded-lg px-3 py-2 outline-none focus:border-black"
                                    value={formData.priority}
                                    onChange={e => setFormData({ ...formData, priority: parseInt(e.target.value) })}
                                />
                            </div>
                        </div>
                        <div className="flex justify-end pt-2">
                            <button
                                onClick={handleSave}
                                className="flex items-center gap-2 bg-green-600 text-white px-6 py-2 rounded-lg hover:bg-green-700"
                            >
                                <Save size={18} /> Save Entry
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* <div className="overflow-x-auto">
                <table className="w-full text-left border-collapse">
                    <thead>
                        <tr className="border-b border-gray-200 text-xs text-gray-500 uppercase tracking-wider">
                            <th className="py-3 px-4 font-medium">Topic</th>
                            <th className="py-3 px-4 font-medium w-1/2">Content</th>
                            <th className="py-3 px-4 font-medium">Tags</th>
                            <th className="py-3 px-4 font-medium">Priority</th>
                            <th className="py-3 px-4 font-medium text-right">Actions</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                        {entries.map(entry => (
                            <tr key={entry._id} className="hover:bg-gray-50 text-sm">
                                <td className="py-3 px-4 font-medium text-gray-900">{entry.topic}</td>
                                <td className="py-3 px-4 text-gray-600 line-clamp-2">{entry.content}</td>
                                <td className="py-3 px-4">
                                    <div className="flex gap-1 flex-wrap">
                                        {entry.tags.map(t => (
                                            <span key={t} className="px-2 py-0.5 bg-gray-100 rounded text-xs text-gray-600">{t}</span>
                                        ))}
                                    </div>
                                </td>
                                <td className="py-3 px-4 text-gray-600">{entry.priority}</td>
                                <td className="py-3 px-4 text-right">
                                    <button onClick={() => handleDelete(entry._id)} className="text-red-500 hover:text-red-700 p-1">
                                        <Trash2 size={16} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                        {entries.length === 0 && (
                            <tr>
                                <td colSpan="5" className="py-8 text-center text-gray-500">
                                    No knowledge entries yet. Add one to get started.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div> */}
        </div>
    );
};

export default KnowledgeBase;
